"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Modal;

var _core = require("@material-ui/core");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Modal(_ref) {
  var open = _ref.open,
      onOpen = _ref.onOpen,
      title = _ref.title,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["open", "onOpen", "title", "children"]);

  var handleClose = function handleClose() {
    onOpen(false);
  };

  return /*#__PURE__*/React.createElement(_core.Dialog, _extends({
    open: open,
    onClose: handleClose,
    "aria-labelledby": "responsive-dialog-title"
  }, props), /*#__PURE__*/React.createElement(_core.DialogTitle, {
    id: "responsive-dialog-title"
  }, title), /*#__PURE__*/React.createElement(_core.DialogContent, null, children));
}